import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { editFn, depInfoFn } from 'api/org/dep';
import staffSearch from '_c/staff-search';
export default {
  components: {
    staffSearch: staffSearch
  },
  data: function data() {
    return {
      oraName: '',
      visible: false,
      disabled: false,
      selectLoading: false,
      supervisorOptions: [],
      dataForm: {
        department_id: '',
        department_name: '',
        supervisor_id: '',
        supervisor_name: ''
      },
      dataRule: {
        department_name: [{
          required: true,
          message: this.$t('780')
        }],
        supervisor_id: [{
          required: true,
          message: this.$t('782')
        }]
      },
      supervisorInfo: {}
    };
  },
  methods: {
    init: function init(info) {
      this.visible = true;
      this.getDepInfo(info.id || info.department_id);
      this.oraName = info.id ? this.$t('1211') : this.$t('1080');
    },
    getDepInfo: function getDepInfo(id) {
      var _this = this;
      depInfoFn({
        department_id: id
      }).then(function (res) {
        _this.dataForm.department_id = id;
        _this.dataForm.department_name = res.data.department_name;
        _this.dataForm.ancestry_name = res.data.ancestry_name;
        var supervisorInfo = {};
        if (res.data.supervisor_name) {
          supervisorInfo.staff_name = res.data.staff_name;
          supervisorInfo.staff_name_en = res.data.staff_name_en;
          supervisorInfo.staff_name_th = res.data.staff_name_th;
          supervisorInfo.staff_name_secondary = res.data.supervisor_name;
          supervisorInfo.staff_id = res.data.supervisor_id;
          _this.dataForm.supervisor_name = res.data.supervisor_name;
          _this.dataForm.supervisor_id = res.data.supervisor_id;
        }
        _this.$refs.staffSearch.res = supervisorInfo;
        _this.$refs.staffSearch.supOptions = [supervisorInfo].filter(function (v) {
          return v.staff_name;
        });
        _this.$nextTick(function () {
          return _this.$refs.dataForm.clearValidate();
        });
      });
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;
      this.$refs.dataForm.validate(function (valid) {
        if (valid) {
          _this2.disabled = true;
          editFn(_this2.dataForm).then(function (res) {
            _this2.disabled = false;
            if (res && res.code === 1) {
              _this2.visible = false;
              _this2.$emit('refreshOrgInfo');
              _this2.$message.success(res.message);
            }
          }).catch(function () {
            _this2.disabled = false;
          });
        }
      });
    },
    staffChange: function staffChange(val) {
      this.dataForm.supervisor_name = val.staff_name;
      this.dataForm.supervisor_id = val.staff_id;
    },
    dialogClosed: function dialogClosed() {
      this.$parent.isSetDialog = false;
    }
  }
};